import { fromJS } from 'immutable'
import * as actionTypes from './constants'
import { LOGOUT, SET_USER } from '../authentication/constants'
import { MOVE_PIN_TO_PLAN_DONE } from '../Plan/constants'
import { sortPins } from '../../utils/sortManager'

const initialState = fromJS({
  splitViewSort: 'LastModified', // [LastModified, Created, Title, Category, Plan, State]
  listViewSort: 'LastModified', // [LastModified, Title, Category, Plan, State]
  listViewSortDirection: 'DESC', // [ASC, DESC]
  listSearch: '',
  listQuickFilter: 'Any', // [Any, ByMe, ByOthers]
  listStateFilter: 'Active', // [Active, Inactive, All]
  page: 0,
  maxPage: 0,
  totalElements: 0,
  listViewSize: 25,
  projectPins: {}
})
const initialAction = {}

const planViewerReducer = (state = initialState, action = initialAction) => {
  const updatePinList = () => {
    let newState = state
    if (state.get('projectPins')) {
      // delete old pins and insert new pins on the rigth sorted place
      const sortProjectPinsFunc = sortPins(
        state.get('listViewSort'),
        state.get('listViewSortDirection')
      )

      action.pins.forEach((updatedPin) => {
        let saved = false
        let deleted = false
        let lastPage = 0

        state.get('projectPins').forEach((pageContent, page) => {
          lastPage = page

          pageContent.forEach((pin, key) => {
            const projectPins = newState.get('projectPins')

            let pinIndex = key
            if (!saved && deleted) {
              pinIndex -= 1
            } else if (saved && !deleted) {
              pinIndex += 1
            }

            if (!saved) {
              const updatedPinMap = fromJS(updatedPin)
              const pinCompared = sortProjectPinsFunc(updatedPinMap, pin)
              if (pinCompared === -1) {
                if (pin.get('id') !== updatedPin.id) {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).insert(pinIndex, updatedPinMap)
                    )
                  )
                } else {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).set(pinIndex, updatedPinMap)
                    )
                  )
                  deleted = true
                }
                saved = true
              } else if (pinCompared === 0) {
                if (pin.get('id') !== updatedPin.id) {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).insert(pinIndex + 1, updatedPinMap)
                    )
                  )
                } else {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).set(pinIndex, updatedPinMap)
                    )
                  )
                  deleted = true
                }
                saved = true
              } else if (pin.get('id') === updatedPin.id) {
                newState = newState.set(
                  'projectPins',
                  projectPins.set(page, projectPins.get(page).delete(pinIndex))
                )
                deleted = true
              }
            } else if (!deleted && pin.get('id') === updatedPin.id) {
              newState = newState.set(
                'projectPins',
                projectPins.set(page, projectPins.get(page).delete(pinIndex))
              )
              deleted = true
            }
          })
        })

        if (!saved && newState.get('projectPins').get(lastPage)) {
          newState = newState.set(
            'projectPins',
            newState
              .get('projectPins')
              .set(
                lastPage,
                newState
                  .get('projectPins')
                  .get(lastPage)
                  .push(fromJS(updatedPin))
              )
          )
        }
      })
    }

    if (state.get('planPins')) {
      action.pins.forEach((pin) => {
        newState = newState.set(
          'planPins',
          newState.get('planPins').set(
            newState.get('planPins').findIndex((p) => p.get('id') === pin.id),
            fromJS(pin)
          )
        )
      })
      newState = newState.set(
        'planPins',
        newState.get('planPins').sort(sortPins(newState.get('splitViewSort')))
      )
    }
    return newState
  }
  switch (action.type) {
    case actionTypes.GET_PAGED_PLAN_PINS:
      return state
        .set('gettingPlanPins', true)
        .delete('planPins')
        .delete('getPlanPinsError')
        .set('filterId', action.filterId)
    case actionTypes.GET_PLAN_PINS_PAGE_DONE: {
      let planPins
      const pins = fromJS(
        action.pins && action.pins.content ? action.pins.content : action.pins
      )
      if (!action.firstPage) {
        if (state.has('planPins')) {
          planPins = state.get('planPins').concat(pins)
        }
      } else {
        planPins = pins
      }
      const newState = state.set(
        'planPins',
        planPins.sort(sortPins(state.get('splitViewSort')))
      )
      if (state.get('pinListType') === 'project') return newState
      return newState.set('totalElements', action.pins.totalElements)
    }
    case actionTypes.GET_PAGED_PLAN_PINS_DONE:
      return state.set('gettingPlanPins', false)
    case actionTypes.GET_PAGED_PLAN_PINS_ERROR:
    case actionTypes.GET_INACTIVE_PLAN_PINS_ERROR:
      return state
        .set('gettingPlanPins', false)
        .set('getPlanPinsError', action.error)

    case actionTypes.SET_PIN_LIST_TYPE:
      return state.set('pinListType', action.pinListType)

    case actionTypes.GET_PROJECT_PINS: {
      let newState = state
      if (state.get('listViewProjectId') !== action.projectId) {
        newState = state.set('projectPins', fromJS({}))
      }

      return newState
        .set('gettingProjectPins', true)
        .set('listViewProjectId', action.projectId)
        .delete('getProjectPinsError')
        .set('filterId', action.filterId)
    }
    case actionTypes.GET_PROJECT_PINS_DONE:
      return state
        .set('gettingProjectPins', false)
        .set('maxPage', action.projectPins.totalPages)
        .set('totalElements', action.projectPins.totalElements)
        .set(
          'projectPins',
          state
            .get('projectPins')
            .set(state.get('page'), fromJS(action.projectPins.content))
        )
    case actionTypes.GET_PROJECT_PINS_ERROR:
      return state
        .set('gettingProjectPins', false)
        .set('getProjectPinsError', action.error)

    case actionTypes.GET_ALL_PROJECT_PINS: {
      return state.set('gettingAllProjectPins', true)
    }
    case actionTypes.GET_ALL_PROJECT_PINS_DONE: {
      return state
        .set('allProjectPinsDone', action.allProjectPins)
        .set('gettingAllProjectPins', false)
    }
    case actionTypes.GET_ALL_PROJECT_PINS_ERROR: {
      return state.set('gettingAllProjectPinsError', action.error)
    }

    case actionTypes.GET_INACTIVE_PLAN_PINS:
      return state
        .set('gettingPlanPins', true)
        .delete('inactivePlanPins')
        .delete('getPlanPinsError')
    case actionTypes.GET_INACTIVE_PLAN_PINS_DONE:
      return state
        .set('gettingPlanPins', false)
        .set('inactivePlanPins', fromJS(action.planPins))

    case actionTypes.SAVE_PIN:
      return state
        .set('savingPin', true)
        .delete('savePinError')
        .delete('newCreatedPin')
    case actionTypes.SAVE_PIN_DONE: {
      let newState = state
      if (state.get('projectPins')) {
        const sortProjectPinsFunc = sortPins(
          state.get('listViewSort'),
          state.get('listViewSortDirection')
        )
        let saved = false
        let lastPage = 0

        state.get('projectPins').forEach((pageContent, page) => {
          lastPage = page

          if (!saved) {
            pageContent.forEach((pin, key) => {
              if (!saved) {
                const actionPinMap = fromJS(action.pin)
                const pinCompared = sortProjectPinsFunc(actionPinMap, pin)
                const projectPins = newState.get('projectPins')
                if (pinCompared === -1) {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).insert(key, actionPinMap)
                    )
                  )
                  saved = true
                } else if (pinCompared === 0) {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).insert(key + 1, actionPinMap)
                    )
                  )
                  saved = true
                }
              }
            })
          }
        })

        if (!saved && newState.get('projectPins').get(lastPage)) {
          newState = newState.set(
            'projectPins',
            newState
              .get('projectPins')
              .set(
                lastPage,
                newState
                  .get('projectPins')
                  .get(lastPage)
                  .push(fromJS(action.pin))
              )
          )
        }
      }

      return newState
        .set('savingPin', false)
        .set(
          'planPins',
          state
            .get('planPins')
            .insert(0, fromJS(action.pin))
            .sort(sortPins(state.get('splitViewSort')))
        )
        .set('newCreatedPin', action.pin)
        .set('totalElements', newState.get('totalElements') + 1)
    }
    case actionTypes.SAVE_PIN_ERROR:
      return state.set('savingPin', false).set('savePinError', action.error)
    case actionTypes.REMOVE_SAVE_PIN_ERROR:
      return state.delete('savePinError').delete('copyPinError')

    case actionTypes.COPY_PIN:
      return state
        .set('copyingPin', true)
        .delete('copyPinError')
        .delete('copiedPin')
    case actionTypes.COPY_PIN_DONE: {
      let newState = state
      if (state.get('projectPins')) {
        const sortProjectPinsFunc = sortPins(
          state.get('listViewSort'),
          state.get('listViewSortDirection')
        )
        let saved = false
        let lastPage = 0

        state.get('projectPins').forEach((pageContent, page) => {
          lastPage = page

          if (!saved) {
            pageContent.forEach((pin, key) => {
              if (!saved) {
                const actionPinMap = fromJS(action.pin)
                const pinCompared = sortProjectPinsFunc(actionPinMap, pin)
                const projectPins = newState.get('projectPins')
                if (pinCompared === -1) {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).insert(key, actionPinMap)
                    )
                  )
                  saved = true
                } else if (pinCompared === 0) {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).insert(key + 1, actionPinMap)
                    )
                  )
                  saved = true
                }
              }
            })
          }
        })

        if (!saved && newState.get('projectPins').get(lastPage)) {
          newState = newState.set(
            'projectPins',
            newState
              .get('projectPins')
              .set(
                lastPage,
                newState
                  .get('projectPins')
                  .get(lastPage)
                  .push(fromJS(action.pin))
              )
          )
        }
      }

      return newState
        .set('copyingPin', false)
        .set(
          'planPins',
          state
            .get('planPins')
            .insert(0, fromJS(action.pin))
            .sort(sortPins(state.get('splitViewSort')))
        )
        .set('copiedPin', action.pin)
    }
    case actionTypes.COPY_PIN_ERROR:
      return state.set('copyingPin', false).set('copyPinError', action.error)

    case actionTypes.UPDATE_PIN_IN_LIST: {
      let newState = state
      if (state.get('projectPins')) {
        // delete old one and insert new one on the rigth sorted place
        const sortProjectPinsFunc = sortPins(
          state.get('listViewSort'),
          state.get('listViewSortDirection')
        )
        let saved = false
        let deleted = false
        let lastPage = 0

        state.get('projectPins').forEach((pageContent, page) => {
          lastPage = page
          pageContent.forEach((pin, key) => {
            const projectPins = newState.get('projectPins')

            let pinIndex = key
            if (!saved && deleted) {
              pinIndex -= 1
            } else if (saved && !deleted && page === 0) {
              pinIndex += 1
            } else if (saved && deleted && page > 0) {
              pinIndex -= 1
            }

            if (!saved) {
              const updatedPinMap = fromJS(action.pin)
              const pinCompared = sortProjectPinsFunc(updatedPinMap, pin)
              if (pinCompared === -1) {
                if (pin.get('id') !== action.pin.id) {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).insert(pinIndex, updatedPinMap)
                    )
                  )
                } else {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).set(pinIndex, updatedPinMap)
                    )
                  )
                  deleted = true
                }
                saved = true
              } else if (pinCompared === 0) {
                if (pin.get('id') === action.pin.id) {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).set(pinIndex, updatedPinMap)
                    )
                  )
                  deleted = true
                  saved = true
                }
              } else if (pin.get('id') === action.pin.id) {
                newState = newState.set(
                  'projectPins',
                  projectPins.set(page, projectPins.get(page).delete(pinIndex))
                )
                deleted = true
              }
            } else if (!deleted && pin.get('id') === action.pin.id) {
              newState = newState.set(
                'projectPins',
                projectPins.set(page, projectPins.get(page).delete(pinIndex))
              )
              deleted = true
            }
          })
        })

        if (!saved && newState.get('projectPins').get(lastPage)) {
          newState = newState.set(
            'projectPins',
            newState
              .get('projectPins')
              .set(
                lastPage,
                newState
                  .get('projectPins')
                  .get(lastPage)
                  .push(fromJS(action.pin))
              )
          )
        }
      }

      if (state.get('planPins')) {
        newState = newState.set(
          'planPins',
          newState
            .get('planPins')
            .set(
              newState
                .get('planPins')
                .findIndex((pin) => pin.get('id') === action.pin.id),
              fromJS(action.pin)
            )
            .sort(sortPins(newState.get('splitViewSort')))
        )
      }

      return newState
    }
    case actionTypes.SORT_SPLIT_VIEW_PINS:
      if (state.has('userId')) {
        localStorage.setItem(
          `pinListViewSortBy-${state.get('userId')}`,
          action.sort
        )
      }

      return state
        .set('splitViewSort', action.sort)
        .set(
          'planPins',
          state.get('planPins')
            ? state.get('planPins').sort(sortPins(action.sort))
            : undefined
        )
        .set('listViewSort', action.sort)
        .set(
          'listViewSortDirection',
          ['LastModified', 'Created'].includes(action.sort) ? 'DESC' : 'ASC'
        )

    case actionTypes.SORT_LIST_VIEW_PINS:
      if (state.has('userId')) {
        localStorage.setItem(
          `pinListViewSortBy-${state.get('userId')}`,
          action.sort
        )
      }

      return state
        .set('listViewSort', action.sort)
        .set('listViewSortDirection', action.sortDirection)
        .set('projectPins', fromJS({}))
        .set('page', 0)
        .set('maxPage', 0)
    case actionTypes.CHANGE_LIST_SEARCH:
      return state
        .set('listSearch', action.search)
        .set('projectPins', fromJS({}))
        .set('page', 0)
        .set('maxPage', 0)
    case actionTypes.CHANGE_LIST_QUICK_FILTER:
      return state
        .set('listQuickFilter', action.quickFilter)
        .set('projectPins', fromJS({}))
        .set('page', 0)
        .set('maxPage', 0)
    case actionTypes.CHANGE_LIST_STATE_FILTER:
      return state
        .set('listStateFilter', action.stateFilter)
        .set('projectPins', fromJS({}))
        .set('page', 0)
        .set('maxPage', 0)
    case actionTypes.CHANGE_PAGE:
      return state.set('page', Number(action.page))
    case actionTypes.CHANGE_LIST_VIEW_SIZE:
      return state
        .set('listViewSize', Number(action.size))
        .set('projectPins', fromJS({}))
        .set('page', 0)
        .set('maxPage', 0)

    case MOVE_PIN_TO_PLAN_DONE: {
      let newState = state
      if (state.get('projectPins')) {
        const sortProjectPinsFunc = sortPins(
          state.get('listViewSort'),
          state.get('listViewSortDirection')
        )
        let saved = false
        let lastPage = 0

        state.get('projectPins').forEach((pageContent, page) => {
          lastPage = page

          if (!saved) {
            pageContent.forEach((pin, key) => {
              if (!saved) {
                const actionPinMap = fromJS(action.pin)
                const pinCompared = sortProjectPinsFunc(actionPinMap, pin)
                const projectPins = newState.get('projectPins')
                if (pinCompared === -1) {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).insert(key, actionPinMap)
                    )
                  )
                  saved = true
                } else if (pinCompared === 0) {
                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).insert(key + 1, actionPinMap)
                    )
                  )
                  saved = true
                }
              }
            })
          }
        })

        if (!saved && newState.get('projectPins').get(lastPage)) {
          newState = newState.set(
            'projectPins',
            newState
              .get('projectPins')
              .set(
                lastPage,
                newState
                  .get('projectPins')
                  .get(lastPage)
                  .push(fromJS(action.pin))
              )
          )
        }
      }

      return state
        .set(
          'planPins',
          state
            .get('planPins')
            .insert(0, fromJS(action.pin))
            .sort(sortPins(state.get('splitViewSort')))
        )
        .set('newCreatedPin', action.pin)
    }
    case actionTypes.UPDATE_PINS_BATCH:
      return state.set('updatingPinsBatch', true).delete('updatePinsBatchError')
    case actionTypes.UPDATE_PINS_BATCH_DONE: {
      const newState = updatePinList()
      return newState.set('updatingPinsBatch', false)
    }
    case actionTypes.UPDATE_PINS_BATCH_ERROR:
      return state
        .set('updatingPinsBatch', false)
        .set('updatePinsBatchError', action.error)

    case actionTypes.UPDATE_BULK_PINS:
      return state.set('updatingBulkPins', true)
    case actionTypes.UPDATE_BULK_PINS_DONE: {
      let newState = state
      if (action.source.records) {
        if (state.get('projectPins')) {
          action.source.records.forEach((updatedPinId) => {
            state.get('projectPins').forEach((pageContent, page) => {
              pageContent.forEach((pin, key) => {
                const projectPins = newState.get('projectPins')
                if (pin.get('id') === updatedPinId) {
                  const newPin = pin.merge(fromJS(action.update))

                  newState = newState.set(
                    'projectPins',
                    projectPins.set(
                      page,
                      projectPins.get(page).set(key, newPin)
                    )
                  )
                }
              })
            })
          })
        }
        if (state.get('planPins')) {
          action.source.records.forEach((pin) => {
            const pinIndex = newState
              .get('planPins')
              .findIndex((p) => p.get('id') === pin)
            let oldPin = newState.get('planPins').get(pinIndex)
            oldPin = oldPin.merge(fromJS(action.update))

            newState = newState.set(
              'planPins',
              newState.get('planPins').set(pinIndex, oldPin)
            )
          })
          newState = newState.set(
            'planPins',
            newState
              .get('planPins')
              .sort(sortPins(newState.get('splitViewSort')))
          )
        }
      }
      return newState.set('updatingBulkPins', false)
    }
    case actionTypes.UPDATE_BULK_PINS_ERROR:
      return state
        .set('updatingBulkPins', false)
        .set('updateBulkPinsError', action.error)

    case actionTypes.EXPORT_PLAN:
      return state.set('exportingPlan', true).delete('exportPlanError')
    case actionTypes.EXPORT_PLAN_DONE: {
      // const downloadLink = lodash.find(action.exportedPlan.links, (link) => link.rel === 'download').href
      return state.set('exportingPlan', false)
    }

    case actionTypes.EXPORT_PLAN_ERROR:
      return state
        .set('exportPlanError', action.error)
        .set('exportingPlan', false)

    case actionTypes.CLEAR_PLAN_VIEWER:
      return state.set('filterId', null)
    case SET_USER: {
      let newState = state
      const userId = action.user ? action.user.userId : newState.get('userId')
      const savedSortBy = localStorage.getItem(`pinListViewSortBy-${userId}`)
      if (savedSortBy) {
        newState = newState
          .set('splitViewSort', savedSortBy)
          .set('listViewSort', savedSortBy)
      }

      return newState.set('userId', userId)
    }
    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default planViewerReducer
